import { Satisfaction } from 'lib-shared-legacy-types';

export namespace LanguageCustomizationForm {
  export enum Fields {
    lookAndFeel = 'look_and_feel',
    ratingQuestion = 'rating_question',
    followupQuestion = 'rating_follow_up_question',
    ratingPlaceholder = 'rating_placeholder_text',
    thankyouMessage = 'rating_completed_message',
  }

  export interface FormValues {
    [Fields.lookAndFeel]: Satisfaction.RatingStyle;
    [Fields.ratingQuestion]: string;
    [Fields.followupQuestion]: string;
    [Fields.ratingPlaceholder]: string;
    [Fields.thankyouMessage]: string;
  }
}
